import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AppHeader } from '../AppHeader';
import { startSession, endSession } from '../../services/dataCollectionService';
import { loadSubscriptionFromSupabase } from '../../services/subscriptionSyncService';
import { logger } from '../../utils/logger';
import './AdvancedLayout.css';

interface AdvancedLayoutProps {
  children: React.ReactNode;
}

export const AdvancedLayout: React.FC<AdvancedLayoutProps> = ({ children }) => {
  const location = useLocation();

  // Hide header on practice hub, in-test, AI exam, dashboard, and subscription (custom top bar)
  const hideMainHeader =
    location.pathname === '/tests' ||
    location.pathname === '/subscription' ||
    location.pathname.startsWith('/practice/') ||
    location.pathname.startsWith('/ai-exam') ||
    location.pathname.startsWith('/dashboard');

  const sessionStartedRef = useRef(false);

  // ── Session tracking + subscription restore on mount ──
  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (!userId) return;

    if (!sessionStartedRef.current) {
      sessionStartedRef.current = true;
      startSession(userId).catch(err =>
        logger.warn('Session start failed:', err)
      );
    }

    const subscriptionTier = localStorage.getItem('subscriptionTier');
    if (!subscriptionTier) {
      loadSubscriptionFromSupabase(userId).catch(err =>
        logger.warn('Subscription restore failed:', err)
      );
    }

    const handleBeforeUnload = () => {
      endSession(0, 0);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      endSession(0, 0);
    };
  }, []);

  return (
    <div
      className="advanced-layout"
      data-no-main-header={hideMainHeader ? 'true' : undefined}
    >
      {/* Header — hidden during practice tests, AI exam, and dashboard */}
      {!hideMainHeader && <AppHeader />}

      <main
        className="main-content"
        style={{ paddingTop: hideMainHeader ? 0 : 56 }}
      >
        <div className="main-content-inner">
          {children}
        </div>
      </main>
    </div>
  );
};
